const pricingData = [
    {   periodo: 'Mensual',
        cantidad: '20 Documentos',
        name: 'Bronce',
        text: 'Neque quis est',
        icon: 'bx-walk',
        price: 6,
        primero:"Soporte 24 horas",
        segundo:"1 usuario"
    },
    {
       periodo: 'Mensual',
       cantidad: '40 Documentos',
        name: 'Plata',
        text: 'Quis autem iure',
        icon: 'bx-run',
        price: 10,
        primero:"Soporte 24 horas",
        segundo:"2 usuario"
    },
    {
        periodo: 'Mensual',
        cantidad: '60 Documentos',
        name: 'Platino',
        text: 'Sed ut neque unde',
        icon: 'bx-cycling',
        price: 15,
        primero:"Soporte 24 horas",
        segundo:"3 usuario"
    },
    {periodo: 'Anual',
    cantidad: 'Documentos Ilimitado',
        name: 'Oro',
        text: 'Itaque earum hic',
        icon: 'bx-car',
        price: 120,
        primero:"Soporte 24 horas",
        segundo:"Usuarios ilimitados"
    },
];

export { pricingData };

